











import { convert_instanceid_to_uuid, convert_uuid_byte } from '@/api';
import { TaskFile } from '@/views/taskFile/types';
import { difference, isEmpty } from 'lodash-es';
import Vue, { PropType } from 'vue';
import { TreeItem } from './task-model-view-left-menu.vue';
import Ellipsis from './Ellipsis.vue';

export default Vue.extend({
    components: {
        Ellipsis,
    },
    props: {
        file: { type: Object as PropType<TaskFile> },
        tree: { type: Array as PropType<TreeItem[]> },
        api: { type: Object },
    },
    data() {
        return {
            checked: true,
            defaultProps: {
                children: 'children',
                label: 'name',
            },
        };
    },
    computed: {
        name(): string {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            return this.file?.uploadFile?.fileName;
        },
        defaultChecked(): number[] {
            if (isEmpty(this.tree)) return [];
            const lastchildren: any = [];
            const forxh = (list) => {
                for (let i = 0; i < list.length; i++) {
                    const chlist = list[i];
                    if (chlist.children?.length > 0) {
                        forxh(chlist.children);
                    } else {
                        lastchildren.push(chlist);
                    }
                }
            };
            forxh(this.tree);
            return new Array(lastchildren.pop().key).fill(1).map((v, i) => i);
        },
    },
    methods: {
        handleCheck(a, b) {
            const lastchildren: any = [];
            const forxh = (list) => {
                for (let i = 0; i < list.length; i++) {
                    const chlist = list[i];
                    if (chlist.children?.length > 0) {
                        forxh(chlist.children);
                    } else {
                        lastchildren.push(chlist);
                    }
                }
            };
            forxh(this.tree);
            const allInstanceIds = lastchildren.map((v) => v.instanceIds).flat();
            const checkedInstanceIds = b.checkedNodes
                .filter((v) => v.instanceIds)
                .map((v) => v.instanceIds)
                .flat();
            const hiddenInstanceIds = difference(allInstanceIds, checkedInstanceIds);
            const byteids = hiddenInstanceIds.map((v) => convert_uuid_byte(convert_instanceid_to_uuid(v, 1)));
            this.api.showAll();
            byteids.forEach((v) => this.api.hiddenRenderElement(v));
            this.api.updateView();
        },
    },
});
